function isPlainObject(x) {
    return typeof x === "object" && x !== null && !Array.isArray(x);
}
/**
 * Deep-merge patch into base. Objects recurse; arrays merge by index (objects
 * merge per element; scalars replace at that index).
 */
export function mergeDeep(base, patch) {
    if (!isPlainObject(patch))
        return { ...base };
    const out = { ...base };
    for (const key of Object.keys(patch)) {
        const pv = patch[key];
        if (pv === undefined)
            continue;
        const bv = out[key];
        if (Array.isArray(pv) && Array.isArray(bv)) {
            const max = Math.max(bv.length, pv.length);
            const next = [];
            for (let i = 0; i < max; i++) {
                const p = pv[i];
                const b = bv[i];
                if (p === undefined) {
                    next[i] = b;
                    continue;
                }
                if (b === undefined) {
                    next[i] = p;
                    continue;
                }
                if (isPlainObject(p) && isPlainObject(b)) {
                    next[i] = mergeDeep(b, p);
                }
                else {
                    next[i] = p;
                }
            }
            out[key] = next;
        }
        else if (isPlainObject(pv) && isPlainObject(bv)) {
            out[key] = mergeDeep(bv, pv);
        }
        else {
            out[key] = pv;
        }
    }
    return out;
}
//# sourceMappingURL=mergeDeep.js.map